import { render, staticRenderFns } from "./TmsTextEditor.vue?vue&type=template&id=54cf3480&"
import script from "./TmsTextEditor.vue?vue&type=script&lang=js&"
export * from "./TmsTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./TmsTextEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports